import { Event } from '../global/event.js';
import { Offer } from './offer.js';
import { Bonus } from './bonus.js';
import { Addon } from './addon.js';

export class Product extends Event {
    constructor() {
        super();
        this.offerHolder = document.querySelector('.ce.products.offers');
        this.offerSelector = document.querySelectorAll('.productbox');
        this.bonusHolder = document.querySelector('.offerings');
        this.bonusSelector = document.querySelectorAll('.bonusbox');
        this.addonSelector = document.querySelectorAll('.addon');
        
        this._offers = [];
        this._bonuse = [];
        this._addons = [];
        this._upsells = [];

        this.init();
    };
    
    get offers() {
        return this._offers;
    }
    
    get bonuses() {
        return this._bonuse;
    }
    
    get addons() {
        return this._addons;
    }

    get upsells() {
        return this._upsells;
    }

    init() {
        let displayedProducts = [];
        if(this.offerSelector) {
            this.offerSelector.forEach(product => {
                let element = new Offer(product);

                displayedProducts.push(element.drerz);
                
                element.addEventListener('selectOffer', event => {
                    this.fireEvent(event.type, event.detail);
                });

                element.addEventListener('unselectAllOffers', () => {
                    this.offers.forEach(element => {
                        element.unselect();
                    });
                    this.upsells.forEach(element => {
                        element.unselect();
                    });
                });

                element.addEventListener('unselectAllUpsells', () => {
                    this.upsells.forEach(element => {
                        element.unselect();
                    });
                });

                element.addEventListener('unselectOffer', event => {
                    this.fireEvent(event.type, event.detail);
                });

                (element.isUpsell) ? this._upsells.push(element) : this._offers.push(element);
            });
        }
        
        if(this.bonusSelector) {
            this.bonusSelector.forEach(product => {
                let element = new Bonus(product);

                if (element.isDevice) {
                    displayedProducts.push('GERAET');
                }

                element.addEventListener('selectBonus', event => {
                    this.fireEvent(event.type, event.detail);
                });

                element.addEventListener('unselectBonus', event => {
                    this.fireEvent(event.type, event.detail);
                });

                element.addEventListener('unselectBonuse', () => {
                    this.bonuses.forEach(element => {
                        element.unselect();
                    });
                });

                this._bonuse.push(element);
            });
        }
        
        if(this.addonSelector) {
            this.addonSelector.forEach(product => {
                let element = new Addon(product);

                element.addEventListener('selectAddon', event => {
                    this.fireEvent(event.type, event.detail);
                });

                element.addEventListener('unselectAddon', event => {
                    this.fireEvent(event.type, event.detail);
                });
                
                this._addons.push(element);
            });
        }

        Tracking.push({
            'event' : 'ovs_meta',
            'displayedProducts' : displayedProducts.filter((item, index) => displayedProducts.indexOf(item) === index)
        });
    };
    
    checkStartOffer() {
        let selectedOffer = Cookies.get('ovs_selected_offer') ?? 0;

        if(this.offerHolder) {
            if(this.offerHolder.classList.contains('d-none')) {
                this.offers[0].prefill = true;
                this.offers[0].select();
                return true;
            }

            if (selectedOffer) {
                let found = this.offers.find((offer) => {
                    if (offer.id == selectedOffer) {
                        offer.prefill = true;
                        offer.select();
                        return true;
                    }
                    return false;
                });

                if (found) {
                    return true;
                }
            }
            
            if (!this.offers[0].url) {
                this.offers[0].prefill = true;
                this.offers[0].select();
                return true;
            }
        }
        return false;
    };

    changeBonus(offerId) {
        OVS.app.helper.addClass('.bonus-wrapper', 'd-none');
        OVS.app.helper.removeClass('.bonus-offer-' + offerId, 'd-none');
        OVS.app.helper.removeClass('.bonus-offer-all', 'd-none');
        
        let hasBonus = false;
        this.bonuses.every(bonus => {
            if(!bonus._holder.classList.contains('d-none')) {
                bonus.prefill = true;
                bonus.select();
                hasBonus = true;
                return false;
            }
            return true;
        });
        
        if(!hasBonus) {
            this.hideBonusSection();
            this.fireEvent('noBonus', {});
        } else {
            this.showBonusSection();
        }
    };

    showBonusSection() {
        if(this.bonusHolder) {
            this.bonusHolder.classList.remove('d-none');
        }
    };

    hideBonusSection() {
        if(this.bonusHolder) {
            this.bonusHolder.classList.add('d-none');
        }
    };
}
